'use client';

import { useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';

import { LAYOUT_SIZE } from '@/hooks/useLayoutSize';
import useStorage from '@/hooks/useStorage';
import { EVENT } from '@/utils/event';
import { ROUTER_PATH } from '@/utils/router';

function Page(): JSX.Element | null {
  const scrollContainerRef = useRef<HTMLElement | null>(null);
  const [layoutSize] = useStorage('layoutSize');
  const router = useRouter();

  useEffect(() => {
    // 防止一开始拿不到值的时候也跳路由，形成循环跳转
    if (layoutSize && layoutSize === LAYOUT_SIZE.SMALL) {
      router.replace(ROUTER_PATH.personalAIMobile);
    }
  }, [layoutSize]);

  useEffect(() => {
    scrollContainerRef.current = document.querySelector('#scrollContainer');
    const pahome = document.querySelector('#pahome');

    if (pahome) {
      pahome.removeAttribute('style');
      dispatchEvent(new CustomEvent(EVENT.PAGE_VISIBILITY, { detail: 'pahome' }));
    }

    const scrollTop = sessionStorage.getItem(`scrollPosition_${location.href}`);

    if (scrollTop && scrollContainerRef.current) {
      setTimeout(() => {
        scrollContainerRef.current?.scrollTo({
          top: Number(scrollTop),
          behavior: 'smooth'
        });
        sessionStorage.removeItem(`scrollPosition_${location.href}`);
      }, 100);
    }

    return () => {
      if (pahome) {
        pahome.setAttribute('style', 'display:none');
      }
    };
  }, []);

  return null;
}

export default Page;
